import { IOnifyHelixConfig } from '@/shared/interfaces/IOnifyHelixConfig';
import { inject, InjectionKey } from 'vue';

export const helixConfigKey: InjectionKey<IOnifyHelixConfig> = Symbol('Helix Config');

/**
 * A Vue composable that provides access to the Helix configuration.
 *
 * @function
 * @name useHConfig
 * @description
 * This composable retrieves the Helix configuration object from the Vue dependency injection system.
 * If the configuration is not provided, it throws an error.
 *
 * @returns {Object} The Helix configuration object.
 * @throws {Error} If the Helix configuration is not provided.
 */
export function useHConfig() {
  const helixConfig = inject(helixConfigKey);

  if (!helixConfig) {
    throw new Error('Helix config not provided');
  }

  return helixConfig;
}
